import { paymentsApi } from "api/payments/paymentsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";

export const useDelayedPayments = (
  skip: number,
  limit: number,
  searchPhrase: string = "",
  filter: string = "",
  orderBy: string = "",
) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.DELAYED_PAYMENTS(skip, limit, searchPhrase, filter, orderBy),
    queryFn: () => paymentsApi.fetchDelayed(skip, limit, searchPhrase, filter, orderBy),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.DELAYED_PAYMENTS(skip, limit, searchPhrase, filter, orderBy),
    });
  };

  return { invalidate, isLoading, isFetching, delayedPayments: data?.data.data ?? [], total: data?.data.total ?? 0 };
};
